import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { AttributeFormConstants } from "../../common/Constants";
import { IFormQualifierAttribute } from "./FormQualifierAttribute";

export interface TFormInputValue {
  formAttributeId: number;
  recordOrderNumber: number;
  qualifierAttributeId: number;
  formSectionQualifierId: number;
  formQualifierId: number;
  valueB: string;
  valueC: string;
  valueD: Date;
  valueIdRef: string;
  valueN: number;
  valueRef: string;
  valueV: string;
  visible: boolean;
}

export interface IFormInputValue extends TFormInputValue {
  attribute: IFormQualifierAttribute;
  value: any;
}

export const typeVariableNameMap = {
  [AttributeFormConstants.TYPE_VALUES.CHAR]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_CHAR]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.BLOB]: "valueB",
  [AttributeFormConstants.TYPE_VALUES.CLOB]: "valueC",
  [AttributeFormConstants.TYPE_VALUES.DATE]: "valueD",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_DATE]: "valueD",
  [AttributeFormConstants.TYPE_VALUES.NUMBER]: "valueN",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER]: "valueN",
  [AttributeFormConstants.TYPE_VALUES.REFERENCA]: "valueRef",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_REFERENCA]: "valueRef",
  [AttributeFormConstants.TYPE_VALUES.BLOB]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.DATE_2]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.REFERENCA_2]: "valueRef",
  [AttributeFormConstants.TYPE_VALUES.INT]: "valueN",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_INT]: "valueN"
};

const FormInputValue = Model(
  (model: TFormInputValue): IFormInputValue => {
    const _formInputValue: TFormInputValue = Object.assign({}, model);

    let create = (formInputValue: IFormInputValue): IFormInputValue => {
      let obj = ValidatableObject(formInputValue);

      return obj;
    };
    let _attribute: IFormQualifierAttribute = {} as IFormQualifierAttribute;

    let FormInputValue = {
      get formAttributeId() {
        return _formInputValue.formAttributeId;
      },
      set formAttributeId(values) {
        _formInputValue.formAttributeId = values;
      },
      get recordOrderNumber() {
        return _formInputValue.recordOrderNumber;
      },
      set recordOrderNumber(values) {
        _formInputValue.recordOrderNumber = values;
      },
      get qualifierAttributeId() {
        return _formInputValue.qualifierAttributeId;
      },
      set qualifierAttributeId(values) {
        _formInputValue.qualifierAttributeId = values;
      },
      get formSectionQualifierId() {
        return _formInputValue.formSectionQualifierId;
      },
      set formSectionQualifierId(values) {
        _formInputValue.formSectionQualifierId = values;
      },
      get valueB() {
        return _formInputValue.valueB;
      },
      set valueB(values) {
        _formInputValue.valueB = values;
      },
      get valueC() {
        return _formInputValue.valueC;
      },
      set valueC(values) {
        _formInputValue.valueC = values;
      },
      get valueD() {
        return _formInputValue.valueD;
      },
      set valueD(values) {
        _formInputValue.valueD = values;
      },
      get valueIdRef() {
        return _formInputValue.valueIdRef;
      },
      set valueIdRef(values) {
        _formInputValue.valueIdRef = values;
      },
      get valueN() {
        return _formInputValue.valueN;
      },
      set valueN(values) {
        _formInputValue.valueN = values;
      },
      get valueRef() {
        return _formInputValue.valueRef;
      },
      set valueRef(values) {
        _formInputValue.valueRef = values;
      },
      get valueV() {
        return _formInputValue.valueV;
      },
      set valueV(values) {
        _formInputValue.valueV = values;
      },
      get formQualifierId() {
        return _formInputValue.formQualifierId;
      },

      set formQualifierId(value) {
        _formInputValue.formQualifierId = value;
      },
      get visible() {
        return _formInputValue.visible;
      },
      set visible(value) {
        _formInputValue.visible = value;
      },
      get attribute() {
        return _attribute;
      },
      set attribute(value) {
        _attribute = value;
      },

      get value() {
        if (_formInputValue.visible) {
          return _formInputValue[
            typeVariableNameMap[this.attribute.attributeType]
          ];
        }
        return _formInputValue["valueV"];
      },

      set value(value) {
        if (_formInputValue.visible) {
          _formInputValue[
            typeVariableNameMap[this.attribute.attributeType]
          ] = value;
        } else {
          _formInputValue["valueV"] = value;
        }
      }
    };
    return create(FormInputValue);
  }
);

export default FormInputValue;
